/* eslint-disable react/prop-types */
import { Icon } from "@iconify/react";
import { Button, Card, Flex, Popconfirm, Space, Typography } from "antd";
import RenderIf from "./RenderIf";

export default function UploadFileRenderer({ file, deleteLoading, action, onPreview, activeDelete = true }){
  return (
    <Card
      style={{ marginTop: 20 }}
      styles={{ 
        body: {
          padding:'10px 14px' 
        }
      }}
    >
      <Flex align="center" justify="space-between" >
        <Space direction="vertical" size={2} >
          <Typography.Text style={{ fontWeight: 500, marginBottom: 0 }} >
            {file.name}
          </Typography.Text>
        </Space>
        <Flex gap={12} >
          <Button
            icon={<Icon icon='solar:eye-bold-duotone' />}
            color="cyan"
            variant="outlined"
            size="small"
            onClick={onPreview}
          />
          <RenderIf when={activeDelete} >
            <Popconfirm
              placement="left"
              title="Pemberitahuan"
              description="Yakin ingin hapus file ?"
              okButtonProps={{ 
                danger: true,
                loading: deleteLoading
              }}
              okText="Hapus"
              onConfirm={action.remove}
            >
              <Button
                icon={<Icon icon='solar:trash-bin-minimalistic-bold-duotone' />}
                danger
                size="small"
              />
            </Popconfirm>
          </RenderIf>
        </Flex>
      </Flex>
    </Card>
  )
}